module.exports = __webpack_public_path__ + "img/dep_iceicesandicecream@2x.500d18f6.png";